"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from "@/components/ui/dropdown-menu";
import { getSortLabel } from "@/lib/utils/filters";
interface SortDropdownContentProps {
  sortOptions: {
    id: string;
  }[];
  activeSortBy?: string;
  onSortChange: (sortBy: string) => void;
}
export function SortDropdownContent(t0) {
  const $ = _c(9);
  const {
    sortOptions,
    activeSortBy,
    onSortChange
  } = t0;
  const t = useTranslations("products");
  let t1;
  if ($[0] !== sortOptions || $[1] !== t) {
    let t2;
    if ($[3] !== t) {
      t2 = option => <DropdownMenuRadioItem key={option.id} value={option.id}>{getSortLabel(option.id, t)}</DropdownMenuRadioItem>;
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = sortOptions.map(t2);
    $[0] = sortOptions;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== activeSortBy || $[6] !== onSortChange || $[7] !== t1) {
    t2 = <DropdownMenuRadioGroup value={activeSortBy} onValueChange={onSortChange}>{t1}</DropdownMenuRadioGroup>;
    $[5] = activeSortBy;
    $[6] = onSortChange;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}